import React from 'react';
import { Card, Col, Tag, Row, Space, Typography } from 'antd';
import { UserAddOutlined } from '@ant-design/icons';
import moment from 'moment';
import { formatWholeNumberNaN } from '../../../../../core/utils/campaigns';
import { dateFormat } from '../../../Tasks/configs/designTokens';
import SignUpsIntroductionsModal from './SignUpsInstructionsModal';
import { CopyBlock } from 'react-code-blocks';
import '../../styles/index.scss';

const { Text } = Typography;

const typePicker = (date, value) => {
  let color = 'success';
  if (!date) {
    color = 'secondary';
  } else if (date && value < 1) {
    color = 'danger';
  }

  return color;
};

const colorPicker = (date, value) => {
  let color = 'success';
  if (!date) {
    color = 'default';
  } else if (date && value < 1) {
    color = 'error';
  }

  return color;
};

const SignUpsCard = ({ signUpsTag, generatedTag }) => {
  const { signups, date } = signUpsTag;

  const getGeneratedTag = generatedTag && generatedTag.tag.generatedTag;
  const urlMatch = getGeneratedTag.match(/src='([^']+)'/);
  const version = urlMatch && urlMatch[1] && new URL(urlMatch[1]).searchParams.get('version');

  const signUpsVersionOne = `<script>
window.tracker("trackSelfDescribingEvent", {
  schema: "iglu:com.mediajel.events/sign_up/jsonschema/1-0-2",
  data: {
    uuid: “1234”, // user identifier - string,
    firstName: “john”, // user first name - string,
    lastName: “evans”, // user last name - string,
    emailAddress: “evans@gmail.com”, // email address - string,
    hashedEmailAddress: “evans@gmail.com”, // email address - string,
    phoneNumber: “+13056863198” // optional, phone number - string,
  },
});
</script>`;

  const signUpsVersionTwo = `<script>
window.tracker("trackSelfDescribingEvent", {
  event: {
    schema: "iglu:com.mediajel.events/sign_up/jsonschema/1-0-2",
      data: {
        uuid: "1234", // user identifier - string,
        firstName: "john", // user first name - string,
        lastName: "evans", // user last name - string,
        emailAddress: "evans@gmail.com", // email address - string,
        hashedEmailAddress: "evans@gmail.com", // email address - string,
        phoneNumber: "+13056863198" // optional, phone number - string,
      },
    }
});
</script>`;

  const signUpsGeneratedTag = version === "2" ? signUpsVersionTwo : signUpsVersionOne;

  return (
    <Card 
      title={`SIGN-UPS TAG`} 
      className="tags-card"
      extra={<SignUpsIntroductionsModal signUpsGeneratedTag={signUpsGeneratedTag}  />}
    >
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Text type="secondary">Results shown below may be delayed up to 1 hour</Text>
        </Col>
        <Col span={6}>
          <Tag
            key={1}
            color={colorPicker(date, signups)}
            className="tags-signups__tag"
          >
            <Space direction="vertical" size={0}>
              <Text type={typePicker(date, signups)} strong className="tags-metrics__label">
                <UserAddOutlined className="tags-metrics__label-icon" />
                <span className="tags-metrics__label-text">Sign-Ups</span>
              </Text>
              <Text type={typePicker(date, signups)} strong>
                {formatWholeNumberNaN(signups)}
              </Text>
              <Text type={typePicker(date, signups)} disabled>
                {date ? moment(date).format(dateFormat.full) : 'Signal Unknown'}
              </Text>
            </Space>
          </Tag>
        </Col>
        <Col span={24}>
          <Card
            className="tags-signups__code-card"
          >
            <CopyBlock
              text={signUpsGeneratedTag}
              language="javascript"
              wrapLongLines
              theme="dracula"
            />
          </Card>
        </Col>
      </Row>
    </Card>
  );
};

export default SignUpsCard;
